// import './styles/App.css';
import Main from './components/Main';
import './styles/bootstrap/css/bootstrap.min.css';
import './styles/App.css';
import './styles/Responsive.css';
import './styles/Navbar.css';

function App() {
  return (
    <Main />
  );
}

export default App;
